import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "" }) {
  return (
    <Link to="/" data-testid="brand-logo" className={`inline-flex items-center gap-2 group ${className}`}>
      <div className="relative w-9 h-9 rounded-xl overflow-hidden flex items-center justify-center"
           style={{ background: "linear-gradient(135deg, #D946EF 0%, #06B6D4 100%)" }}>
        <span className="font-display font-black text-white text-lg leading-none">B</span>
      </div>
      <div className="flex flex-col leading-none">
        <span className="font-display text-lg font-extrabold tracking-tight text-white">AI Bazaar</span>
        <span className="text-[9px] uppercase tracking-[0.24em] text-zinc-500">Studio · v1</span>
      </div>
    </Link>
  );
}
